import { FC } from 'react';

interface ModalCloseButtonProps {
    onClick: () => void;
    className?: string;
}

const ModalCloseButton: FC<ModalCloseButtonProps> = ({ onClick, className }) => {
    return (
        <button className={className} onClick={onClick}>
            <picture>
                <source
                    srcSet="/images/modal/closemobile.svg"
                    width={7.5}
                    height={7.5}
                    media="(max-width: 768px)"
                />
                <img
                    height={12}
                    width={12}
                    src="/images/modal/close.svg"
                    style={{ opacity: 0.4 }}
                    alt="Close modal"
                />
            </picture>
        </button>
    );
};

export default ModalCloseButton;
